import { sortBy, groupBy, memoize } from 'lodash';
import CHECKLIST_DATA from '../assets/CHECKLIST.json';

export type Entry = {
    id: number;
    position: number;
    location: string;
    section: string;
    description: string;
    selected?: boolean;
};

export type GroupedData = {
    [index: string]: Entry[];
};

const sortData = (data: Entry[]): Entry[] =>
    sortBy(data, (entry) => entry.position);

const groupBySection = (data: Entry[]): GroupedData =>
    groupBy(data, (entry) => entry.section);

const getChecklist = memoize((): Entry[] => sortData(CHECKLIST_DATA));

export { getChecklist, groupBySection };
